/* eslint-disable no-nested-ternary */
import { Link } from "gatsby";
import React from "react";

import { paginationSlugGen } from "../../../utils/paginationSlugGen";
import { Svg } from "../../../components/Svg";

// const PartialNumber = ({ currentPageNum }) => {
//   return (
//     <>
//       <BtnLink
//         to={paginationSlugGen(1)}
//         rel="prev"
//         isDisabled={currentPageNum === 1}
//         isRounded={false}
//       >
//         {2}
//       </BtnLink>
//       <BtnLink
//         to="/"
//         rel="prev"
//         isDisabled={currentPageNum === 0}
//         isRounded={false}
//       >
//         {PAGINATION.HOME}
//       </BtnLink>
//     </>
//   );
// };

// const PaginationNumberInc = ({ totalPagesNum, currentPageNum }) => {
//   const isNextAvailable = hasNextPage(currentPageNum, totalPagesNum);
//   return (
//     <>
//       {currentPageNum !== totalPagesNum && (
//         <>
//           <BtnLink Component="span" isDisabled isRounded={false}>
//             ...
//           </BtnLink>
//         </>
//       )}

//       {currentPageNum + 2 >= 3 && (
//         <>
//           <BtnLink
//             isDisabled={!isNextAvailable}
//             to={paginationSlugGen(currentPageNum + 1)}
//             rel="prev"
//             isRounded={false}
//           >
//             {isNextAvailable ? currentPageNum + 2 : currentPageNum + 1}
//           </BtnLink>
//           {currentPageNum + 2 > 3 && (
//             <BtnLink Component="span" isDisabled isRounded={false}>
//               ...
//             </BtnLink>
//           )}
//         </>
//       )}
//     </>
//   );
// };

const PAGINATION = {
  // HOME: "1",
  PREV_PAGE: "السابق",
  NEXT_PAGE: "التالي",
};

const BtnLink = ({
  Component = Link,
  to,
  rel,
  isRounded,
  isLeft,
  isDisabled,
  children,
}) => {
  return (
    <Component
      className={`-ml-px relative inline-flex items-center shadow py-2 ${
        isRounded
          ? isLeft
            ? "px-2 rounded-l-lg"
            : "px-2 rounded-r-lg"
          : "px-4"
      } border border-brand text-sm leading-5 font-semibold ${
        isDisabled
          ? "shadow-none pointer-events-none text-subtle"
          : "text-darker hover:font-extrabold hover:text-brand focus:z-10 focus:outline-none focus:font-thin focus:border-brandLight focus:shadow-outline-brand"
      } transition ease-in-out duration-150`}
      to={to}
      rel={rel}
    >
      {children}
    </Component>
  );
};

const hasNextPage = (currentPage, totalPagesNum) =>
  currentPage !== totalPagesNum;

// Note: pages start from 1
const hasPrevPage = (currentPage) => currentPage > 0;

const PaginationWrapper = ({ totalPagesNum, currentPageNum, children }) => {
  return (
    <nav className="flex-col items-center mb-10">
      <div className="flex">
        <BtnLink
          to={paginationSlugGen(currentPageNum + 1)}
          rel="next"
          isRounded
          isLeft={false}
          isDisabled={!hasNextPage(currentPageNum, totalPagesNum)}
        >
          <Svg
            title={PAGINATION.NEXT_PAGE}
            path="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
          />
          {PAGINATION.NEXT_PAGE}
        </BtnLink>
        {children}

        <BtnLink
          to={paginationSlugGen(currentPageNum - 1)}
          rel="prev"
          isRounded
          isLeft
          isDisabled={!hasPrevPage(currentPageNum)}
        >
          {PAGINATION.PREV_PAGE}
          <Svg
            title={PAGINATION.PREV_PAGE}
            path="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
          />
        </BtnLink>
      </div>
    </nav>
  );
};

const Pagination = ({
  currentPageNum, // starts from zero
  totalPagesNum,
}) => {
  return (
    <PaginationWrapper
      totalPagesNum={totalPagesNum}
      currentPageNum={currentPageNum}
    />
  );
};

export default Pagination;
